module.exports = __webpack_public_path__ + "media/media/values/fedor-semenov-c9f4dd81fb76a6d8bcd6bbdc5191e727.jpg";